//all cost modelling route constants

export const shouldCostLibraryApiRoutes = {
  getShouldCostFilters: '/v1/landing/get-filter-data',
  getShouldCostLandingFilters: '/v1/library/landing/get-filter-data',
  getShouldCostInfoCount: '/v1/cost-modelling/get-landing-banner-count',
  getShouldCostModelsByFilters: '/v1/cost-modelling/get-models-by-filters',
  getShouldCostModelsByFiltersV2: '/v2/cost-modelling/get-models-by-filters',
  getShouldCostKPIs: '/shouldCostSummary/kpi',
  getShouldCostModelDetails: '/v1/cost-modelling/get-should-cost-model-details',
  getModelMetaData: '/v1/should-cost-analysis/get-model-meta-data',
  deleteShouldCostModel: '/v1/cost-modelling/should-cost-library/delete',
  getCommodityData: '/v1/should-cost-analysis/get-commodity',
  getCommodityKPIs: '/v1/should-cost-analysis/commodity-kpi',
  getCostComponentList: '/v1/should-cost-analysis/get-standard-cost-components-list',
  saveCreatedModel: '/v1/cost-modelling/save-breakdown',
  saveAsDraftModel: '/v1/cost-modelling/draft-model',
  previewDownloadShouldCost: '/v1/cost-modelling/preview-download',
  getShouldCostBreakdownForModel: '/v1/cost-modelling/get-should-cost-breakdown',
  editCreatedModel: '/v1/cost-modelling/edit-model',
  getMiniIfaDataPreview: '/v1/cost-modelling/get-mini-ifa-preview-data',
  getBomAndChartDataPreview: '/v1/cost-modelling/get-chart-bom-preview-data',
  getMiniIfa: '/v1/cost-modelling/get-mini-ifa',
  getBomAndChart: '/v1/cost-modelling/get-chart-bom',
  getTotalModelCount: '/v1/cost-modelling/get-total-model-count',
  getTotalModelCountV2: '/v2/cost-modelling/get-total-model-count',
  getDpcdData: '/v1/cost-modelling/get-dpcd-data',
  getPreviewMiniIFABom: '/v1/cost-modelling/get-preview-mini-ifa-bom',
  getPreviewBomV2: '/v2/cost-modelling/get-preview-chart-bom',
  getMiniIfaV2: '/v2/cost-modelling/get-mini-ifa',
  getChartBomV2: '/v2/cost-modelling/get-chart-bom',
  getHTSDetails: '/v1/hts-code/get-hts-details',
  createTopDownModel: '/v1/cost-modelling/create-top-down-model',
  editTopDownModel: '/v1/cost-modelling/edit-top-down-model',
  getTopDownModel: '/v2/cost-modelling/get-should-cost-breakdown',
  getModelMetaDataV2: '/v2/should-cost-analysis/get-model-meta-data',
  getDestinationCountryList: '/v1/cost-modelling/get-destination-countries',
  getDpcdDataV2: '/v2/cost-modelling/get-dpcd-data',
  previewDownloadShouldCostV2: '/v2/cost-modelling/preview-download',
  saveAsDraftTopDownModel: '/v2/cost-modelling/draft-model',
  getAIGeneratedBreakdownV2: 'v2/cost-modelling/genai/breakdown-details',
  getFetchableUrl: 'v1/gen-ai-model/fetch-sku-specs-from-url',
  pinModel: 'v1/cost-modelling/pin-model',
  getHtsCodeDetails: '/v2/hts-code/tariff-details',
}

export const skuShouldCostWorkbenchApiRoutes = {
  getSkuKpis: '/v1/cost-modelling/get-kpi',
  getSkuList: '/v1/cost-modelling/get-sku-list',
  getTotalSkuCount: '/v1/cost-modelling/get-total-sku-count',
  attachModelsToSku: '/v1/cost-modelling/attach-sku-model',
  setFinalModel: '/v1/should-cost-analysis/set-final-model',
  setFinalModelV2: '/v2/cost-modelling/set-final-model',
  getShouldCostBreakdownForModel: '/v1/should-cost-analysis/get-should-cost-breakdown',
  getShouldCostModelsBySku: '/v1/should-cost-analysis/get-shouldcost-models-by-sku',
  checkIfaProgress: '/v2/should-cost-analysis/is-calulating',
  downloadShouldCost: '/v1/cost-modelling/download-should-cost',
  getAllVendorsForSku: '/v1/should-cost-analysis/get-all-vendors-for-sku',
  attachFilesToModel: '/v1/should-cost-analysis/get-should-cost-attachments',
  getShouldCostModelDetails: '/v1/should-cost-analysis/get-should-cost-model-details',
  getCurrencyExchangeRate: '/v1/should-cost-analysis/get-currency-exchange-rate',
  getMaxDate: 'v1/should-cost-analysis/get-commodity-max-date',
  deleteSkuShouldCostMapping: '/v1/cost-modelling/delete-sku-model-mapping',

  downloadFile: 'v1/should-cost-analysis/download-template',
  validateFile: '/v1/should-cost-analysis/validate-files',
  uploadFile: '/v1/should-cost-analysis/upload-files',
  getVendorPoData: 'v1/cost-modelling/get-vendor-po-data',
  getPoTrendData: 'v1/cost-modelling/get-po-trend-data',
  getSKUFilters: 'v1/cost-modelling/get-sku-workbench-filters',
  getPoAndModelsForWorkspace: '/v1/cost-modelling/simulation/po-should-cost-list',
  createSimulationWorkspace: 'v1/cost-modelling/simulation/create-simulation-workspace',
  getSimulationWorkspaceList: '/v1/cost-modelling/simulation/get-simulation-workspace-by-sku',
  deleteSimulationWorkspace: '/v1/cost-modelling/simulation/delete_workspace',
  getSimulationList: '/v1/cost-modelling/simulation/get-homepage-simulations',
  deleteSimulation: '/v1/cost-modelling/simulation/delete_simulation',
  getSimulationBOMForEdit: '/v1/cost-modelling/simulation/get-bom-edit-simulation',
  createSimulation: '/v1/cost-modelling/simulation/create-simulation',
  saveSimulationBOM: '/v1/cost-modelling/simulation/edit-simulation',
  getSimulationSubcomponentCost: '/v1/cost-modelling/simulation/calculate-updated-cost',
  getSimulationSubcomponentDutyTariff: '/v1/cost-modelling/simulation/calculate-updated-hts-cost',
  saveSimulationAsShouldCostModel: '/v1/cost-modelling/simulation/save-simulation-as-model',
  getSimulationBOMDetails: '/v1/cost-modelling/simulation/get-bom-view-simulation',
  getSimulationMiniIfa: '/v1/cost-modelling/simulation/get-simulation-trend',
  getGTOSuggestedCountries: '/gto-suggested-countries',
  getBomTrendViewSimulation: '/v1/cost-modelling/simulation/get-bom-trend-view-simulation',
  getSimulationComparisonData: '/v1/cost-modelling/simulation/get-simulation-comparison-data',
  getTrendDataByWorkspace: '/v1/cost-modelling/simulation/get-trend-by-workspace',
  getSimulationPreviewData: '/v1/cost-modelling/simulation/get-simulation-preview-data',
  triggerModelCreation: '/v1/cost-modelling/trigger-model-creation',
  getSkuMetaData: '/v1/cost-modelling/get-sku-meta-data',
  getWorkspaceMetaData: '/v1/cost-modelling/get-workspace-meta-data',
  getSimulationMetaData: '/v1/cost-modelling/get-simulation-meta-data',
  getBaseModelData: '/v1/cost-modelling/get-base-model-details',
  generateDescription: '/v1/cost-modelling/simulation/refresh-description',
  getLogsPercentageAiShouldCosting: '/v1/cost-modelling/get-logs',
  getExtrapolationGroupOptionList: '/v1/cost-modelling/get-sku-grouping-elements',
  getExtrapolationGroupData: '/v1/cost-modelling/fetch-groups',
  createExtrapolationGroup: '/v1/cost-modelling/create-sku-groups',
  getRepresentativeSkus: '/v1/cost-modelling/get-representative-sku-groups',
  getRepresentativeSkusCount: '/v1/cost-modelling/get-total-count-of-representative-sku-groups',
  replaceRepresentativeSku: '/v1/cost-modelling/replace-representative-sku',
  generateAiBasedModels: '/v1/cost-modelling/generate-ai-based-models',
  cancelSkuGrouping: '/v1/cost-modelling/cancel-sku-groups',
  deleteSkuGrouping: '/v1/cost-modelling/delete-sku-groups',
  aiGeneratedSkuGroupModels: '/v1/cost-modelling/review-ai-generated-models',
  abortModelGeneration: '/v1/cost-modelling/abort-model-creation',
  fetchSkuListForExtrapolation: '/v1/cost-modelling/fetch-sku-list-for-extrapolation',
  getTotalSkuListForExtrapolationCount: '/v1/cost-modelling/sku-list-for-extrapolation-count',
  startExtraPolationProcess: '/v1/cost-modelling/start-extrapolation-process',
  saveSkuGroupMappingIds: '/v1/cost-modelling/sku-group-mapping-ids',
  getExtraPolationLogsPercentage: '/v1/cost-modelling/get-extrapolation-process',
  getExtrapolationLog: '/v1/cost-modelling/sku-should-cost-extrapolation-log',
  cancelExtrapolation: '/v1/cost-modelling/cancel-adf-trigger-pipeline',
  completeReview: '/v1/cost-modelling/update-is-reviewed-model-status',
  getCommodityUomConversionRates: '/v1/cost-modelling/get-uom-conversion-rates',
  getFilters: '/v1/data-management/get-filters',
  getSkuGroups: '/v1/cost-modelling/sku-groups',
  deleteSkuGroup: '/v1/cost-modelling/delete-sku-group-by-id',
  getSkuGroupByFilter: '/v1/cost-modelling/fetch-sku-groups-by-filters',
  getSkusByFilter: '/v1/cost-modelling/fetch-skus-by-filters',
  ifaShorlistedSkuCounts: '/v1/cost-modelling/ifa-shortlisted-sku-count',
  createSKUGroups: '/v1/cost-modelling/create-sku-groups',
  getSkuGroupFormula: '/v1/cost-modelling/get-sku-group-formula',
  getExtrapolationSkuCount: '/v1/cost-modelling/count-skus-by-filters',
  getWithoutSkuCount: '/v1/cost-modelling/get-sku-count-to-be-extrapolated',
  downloadShouldCostV2: '/v2/cost-modelling/download-should-cost',
  getShortlistingLogsPercentage: '/v1/cost-modelling/pipeline-run-logs/activity',
  skipAccurateModelGenerationFlow: '/v1/cost-modelling/skip-accurate-flow',
  getUploadCostModelsLogs: '/v1/cost-modelling/get-upload-logs',
  validateUploadedModels: '/v1/model-uploader/validate-uploader-template',
  uploadAndCalculate: '/v1/model-uploader/upload-and-calculate',
  getUploadModelStatus: '/v1/model-uploader/status',
  dismissUploadFailureBanner: '/v1/model-uploader/error-logs',
  markSessionReviewed: '/v1/model-uploader/mark-session-reviewed',
  downloadUploadedModelErrorFile: '/v1/model-uploader/error-logs/download',
  abortUploadSession: '/v1/model-uploader/cancel-upload',
  downloadMultipleModels: '/v1/model-uploader/download-multiple-models',
  getCountsForReviewModels: '/v1/cost-modelling/get-counts-for-review-models',
  getReviewModels: '/v1/bulk-shortlisting/models',
  getReviewModelsFilters: '/v1/bulk-shortlisting/get-filters',
  deleteMultipleModels: '/v1/cost-modelling/delete-multiple-models',
  validateShortlisting: '/v1/bulk-shortlisting/validate-shortlisting',
  uploadShouldCostModelFromExcel: '/v1/model-uploader/library/validate-and-upload',
  getIndexTicker: '/v2/cost-modelling/genai/index-ticker',
}
